export default __webpack_public_path__ + "static/media/icon-select-green.8acdf62c.svg";